<template>
  <catalog-data :table-cfg="tableCfg" :ascending="tableCfg.ascending" isAllSolutions=table-cfg.isAllSolutions />
</template>

<script>
import CatalogData from "./CatalogData.vue";

export default {
  name: "hp-catalog-table",
  components: {
    CatalogData
  },
  props: {
    tableCfg: { type: Object, required: true },
    isAllSolutions: {
      type: Boolean,
    },
  }
};
</script>
